import { Action } from '@ngrx/store';

import { Organisation } from '@digihaven/shared';

export enum OrganisationActionTypes {
    Set = '[Organisation] Set',
    Unset = '[Organisation] Unset'
}

export class SetOrganisation implements Action {
    type: OrganisationActionTypes.Set = OrganisationActionTypes.Set;
    constructor(public payload: Organisation) {}
}

export class UnsetOrganisation implements Action {
    type: OrganisationActionTypes.Unset = OrganisationActionTypes.Unset;
}

export type OrganisationActions = SetOrganisation | UnsetOrganisation;
